import {Injectable} from '@angular/core';
import {Cart, CartItem, CartStatus, PaymentMethod} from './Cart';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {Page} from '@uofu-uss/angular-util';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CartDataService {

  public static readonly cartUrl = '/api/cart';
  public static readonly cartItemUrl = '/api/cart-item';

  constructor(private readonly http: HttpClient) {
  }

  addItem(item: CartItem): Observable<CartItem> {
    return this.http.put<CartItem>(CartDataService.cartItemUrl, item);
  }

  checkout(cart: Cart, paymentMethod = PaymentMethod.CreditCard): Observable<Cart> {
    return this.http.post<Cart>(`${CartDataService.cartUrl}/${cart.id}/checkout?paymentMethod=${paymentMethod}`, null);
  }

  updateCart(cart: Cart): Observable<Cart> {
    return this.http.post<Cart>(`${CartDataService.cartUrl}/${cart.id}`, cart);
  }

  updateItem(item: CartItem): Observable<CartItem> {
    return this.http.post<CartItem>(`${CartDataService.cartItemUrl}/${item.id}`, item);
  }

  removeItem(cartItemId: number): Observable<CartItem> {
    return this.http.delete<CartItem>(`${CartDataService.cartItemUrl}/${cartItemId}`);
  }

  fetchExistingCarts(statuses: ReadonlyArray<CartStatus>, unid: string): Observable<ReadonlyArray<Cart>> {
    return this.http.get<Page<Cart>>(
      `${CartDataService.cartUrl}?page=0&size=1000&statuses=${statuses}&unid=${unid}`
    ).pipe(map(page => page.data));
  }

  fetchCart(id: number): Observable<Cart> {
    return this.http.get<Cart>(`${CartDataService.cartUrl}/${id}`);
  }
}
